import { LAYOUTS } from '@voltmoney/types';
import { HeaderTypeTokens, StepperTypeTokens, WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../../routes';
import { ACTION } from './types';
import { AadharInitAction, BajajAadharInitCoBorrowerAction, digilockerAction, digioCallback, doKYCLaterAction, failedVerification, GoBackAction, successVerification, } from './actions';
import { getCoBorrowerName, getLenderIcon, getLenderInfo, horizontalStepperRepo, removeUrlWithoutReload } from '../../../../configs/utils';
import { Platform } from "react-native";
import { api } from "../../../../configs/api";
import { getAppHeader } from "../../../../configs/config";
import SharedPropsService from "../../../../SharedPropsService";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { LENDER_ID } from "../../../../configs/constants";
export const template = (stepper, lenderInfo, shouldShowDocUploadOption, isLenderBajaj, KycMode, height, successModal, successTitle, successSubTitle, successButtonTitle, failedModal, failedTitle, failedSubTitle, failedButtonTitle, currentStepId, showNewCoborrowerFlow, fullName) => {
    return {
        layout: {
            id: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
            type: LAYOUTS.LIST,
            widgets: [
                { id: 'coBorrowerKycVerificationPage', type: WIDGET.CO_BORROWER_KYC_VERIFICATION },
            ],
        },
        datastore: {
            coBorrowerKycVerificationPage: {
                headerTitle: 'KYC verification',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                backAction: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {},
                },
                lenderInfo,
                lenderIcon: getLenderIcon(lenderInfo?.lenderAccountId),
                aadharInitAction: KycMode === 'BAJAJ' && showNewCoborrowerFlow ? {
                    type: ACTION.BAJAJ_DIGIO_INIT,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {}
                } : {
                    type: ACTION.AADHAR_INIT,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {},
                },
                height,
                successModal,
                successTitle,
                successSubTitle,
                successButtonTitle,
                failedModal,
                failedTitle,
                failedSubTitle,
                failedButtonTitle,
                failureAction: {
                    type: ACTION.FAILED_VERIFICATION,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {},
                },
                continueAction: {
                    type: ACTION.SUCCESS_VERIFICATION,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {
                        value: currentStepId
                    },
                },
                loading: false,
                shouldShowDocUploadOption: shouldShowDocUploadOption,
                documentUploadAction: {
                    type: ACTION.DOCUMENT_UPLOAD,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {},
                },
                doKycLaterAction: {
                    type: ACTION.DO_KYC_LATER,
                    routeId: ROUTE.CO_BORROWER_KYC_DIGIO_BASE,
                    payload: {},
                },
                fullName: fullName
            },
        },
    };
};
export const coBorrowerKYCDigioMf = {
    onLoad: async ({ instrumentTrack, network, getHeight }, { successModal, successTitle, successSubTitle, successButtonTitle, failedModal, failedTitle, failedSubTitle, failedButtonTitle, currentStepId, coBorrowerId, coBorrowerName }) => {
        instrumentTrack("CO_BORROWER_KYC_START_PAGE_VIEWED", { "type": "digilocker" });
        Platform.OS === 'web' ? removeUrlWithoutReload("message") : {};
        if (await AsyncStorage.getItem("application_id") === null) {
            const user = await network.post(api.userContext, {}, {
                headers: await getAppHeader(),
            });
            await SharedPropsService.setUser(user.data);
        }
        const userFromSharedProp = await SharedPropsService.getUser();
        const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : userFromSharedProp.linkedApplications[0].applicationId;
        const lenderInfo = await getLenderInfo(network);
        const isLenderBajaj = userFromSharedProp?.linkedApplications[0]?.lenderAccountId.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
        const routeConfigResponse = await network.post(api.routeConfigNameMisMatch, {
            applicationId: applicationId
        }, {
            headers: await getAppHeader()
        });
        const user = await SharedPropsService.getUser();
        const fullName = coBorrowerName ? coBorrowerName : getCoBorrowerName(user.linkedApplications[0].currentCoBorrowerAccountId, user.linkedApplications[0].coBorrowerAccountMetaData);
        const shouldShowDocUploadOption = routeConfigResponse.data.routeModel.routeOptions.shouldShowDocUploadOption;
        const getKYCModeResponse = await network.get(`${api.getKYCMode}${applicationId}`, {
            headers: await getAppHeader()
        });
        const coBorrowerAccountId = coBorrowerId ? coBorrowerId : user.linkedApplications[0].currentCoBorrowerAccountId;
        const KycMode = getKYCModeResponse?.data;
        const currentStepid = user?.linkedApplications[0]?.currentStepId;
        if (currentStepid === "CO_BORROWER_KYC_SUMMARY") {
            await network.get(`${api.switchCoBorrowerId}${applicationId}/${coBorrowerAccountId}`, {
                headers: await getAppHeader()
            });
        }
        const coBorrowerFlowFromFirebase = await SharedPropsService.getFirebaseConfig().co_borrower_bajaj_flow;
        //@ts-ignore
        const showNewCoborrowerFlow = coBorrowerFlowFromFirebase === true || coBorrowerFlowFromFirebase === "true";
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(stepper, lenderInfo, shouldShowDocUploadOption, isLenderBajaj, KycMode, getHeight(), successModal, successTitle, successSubTitle, successButtonTitle, failedModal, failedTitle, failedSubTitle, failedButtonTitle, currentStepId, showNewCoborrowerFlow, fullName));
    },
    actions: {
        [ACTION.AADHAR_INIT]: AadharInitAction,
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.DOCUMENT_UPLOAD]: digilockerAction,
        [ACTION.DIGIO_ANDROID_CALLBACK]: digioCallback,
        [ACTION.BAJAJ_DIGIO_INIT]: BajajAadharInitCoBorrowerAction,
        [ACTION.DO_KYC_LATER]: doKYCLaterAction,
    },
};
